import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import { Shrimp } from 'lucide-react';
import React from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { UserFeatures } from 'types/user-features.enum';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

type Params = {
  globalSiteId: string;
};

const ProductionSystemsTabHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const {
    account
  } = useAccountState();

  const params = useParams<Params>();
  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: true,
          label: intl.formatMessage({ id: 'productionSystems.farmOverview.title' }),
          to: `/production-systems/farm-overview/${params.globalSiteId ?? ''}`,
        },
        {
          hasAccess: account.company?.userCompanyFeatures?.includes(UserFeatures.FarmSetup),
          label: intl.formatMessage({ id: 'productionSystems.farmSetup.title' }),
          to: `/production-systems/farm-setup/${params.globalSiteId ?? ''}`,
        },
        {
          hasAccess: true,
          label: intl.formatMessage({ id: 'productionSystems.registrationLog.title' }),
          to: `/production-systems/registration-log/${params.globalSiteId ?? ''}`,
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<Shrimp size={25} color={'white'} />}
    />
  );
};

export default React.memo(ProductionSystemsTabHeader);
